var theme = {
  primaryColor: '#1c2def',
  secondaryColor: '#f1f1f1',
  fontFamily: 'Outfit, sans-serif',
};

export default theme;
